export default {
    fetchAvailableResources(resourceName, fieldAttribute, params) {
        return Nova.request().get(`/nova-api/${resourceName}/associatable/${fieldAttribute}`, { params })
    },

    fetchAvailableResourcesComplete(resourceName, fieldAttribute, params) {
        return Nova.request().get(`/nova-api/${resourceName}/associatable-complete/${fieldAttribute}`, { params })
    },

    determineIfSoftDeletes(resourceName) {
        return Nova.request().get(`/nova-api/${resourceName}/soft-deletes`)
    },
}
